// map json
import mapJson from '../../../data/ch-all.geo.json';

// chart options
export const mapChartoptions = {
  chart: {
    type: 'map',
    animation: false,
    backgroundColor: '#eef0f3',
    height: '80%',
    spacing: [0, 0, 0, 0],
  },
  colorAxis: {
    min: 0,
    stops: [
      [0, '#95cae7'],
      [1, '#033e72'],
    ],
    colorAxis: {
      labels: {
        style: { whiteSpace: 'nowrap', textOverflow: 'none' },
      },
    },
  },
  credits: {
    mapText: '',
    mapTextFull: '',
    text: '',
  },
  exporting: {
    chartOptions: {
      title: {
        style: {
          'font-size': '16px',
          'font-weight': 'bold',
          'font-family': 'Arimo, Arial, sans-serif',
        },
      },
      chart: {
        spacing: [10, 10, 10, 10],
      },
      credits: {
        mapText: '',
        mapTextFull: '',
        text: 'IWP – Swiss Inequality Database',
      },
    },
    buttons: {
      contextButton: {
        enabled: false,
      },
    },
  },
  legend: {
    useHTML: true,
    align: 'center',
  },
  map: mapJson,
  mapNavigation: {
    enabled: false,
    buttonOptions: {
      alignTo: 'plotBox',
      align: 'right',
      verticalAlign: 'top',
      style: {
        color: '#fff',
      },
      theme: {
        fill: '#033e72',
        'stroke-width': 1,
        stroke: '#fff',
        r: 0,
      },
    },
  },
  series: [
    {
      mapData: mapJson,
      data: [],
      nullInteraction: true,
    },
  ],
  title: { align: 'left', text: ``, useHTML: true },
  tooltip: {
    backgroundColor: null,
    borderWidth: 0,
    shared: false,
    useHTML: true,
    formatter: function (tooltip) {
      if (this.point.isNull) {
        this.point.isNull = false;
        this.point.formatPrefix = 'point';
        this.point.value = 'N/A';
      }
      return tooltip.defaultFormatter.call(this, tooltip);
    },
    headerFormat: '<div class="hicharttooltip">',
    footerFormat: '</div>',
    shadow: false,
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          chart: {
            height: '100%',
          },
        },
      },
    ],
  },
};
